// extracted by mini-css-extract-plugin
var _1 = "Buttons-modulemargin__zlbJ5";
var _2 = "Buttons-modulewidth__iJpyW";
export { _1 as "margin", _2 as "width" }
